export enum UserPermission {
  tariffDetail = 'tariffDetail',
  tariffList = 'tariffList',
  transitTimeFile = 'transitTimeFile',
  bidFile = 'bidFile',
  rateFile = 'rateFile',
  uploadAmcAutoGriBtns = 'uploadAmcAutoGriBtns',
  tariffManagement = 'TariffManagement',
  security = 'Security',
}
